export const convertTenantMenuToLayoutWizMenu = (menu) => {
  return {
    id: menu.menuKey,
    index: menu.url,
    title: menu.meta.title,
    icon: menu.icon,
    isHomeMenu: menu.meta.isHomeMenu,
    hidden: menu.meta.hidden,
    openType: menu.meta.openType,
    meta: {
      operations: menu.meta.operations,
    },
  }
}

export const convertTenantMenusToLayoutWizMenus = (menus) => {
  const retMenus = []
  menus.forEach((m) => {
    const pm = convertTenantMenuToLayoutWizMenu(m)
    if (m.children && m.children.length > 0) {
      const cms = convertTenantMenusToLayoutWizMenus(m.children)
      pm.children = cms
    }
    retMenus.push(pm)
  })
  return retMenus
}
